import axios from "axios";
import {
    SET_DOWNLOAD_XOSC_FILE_REQUEST,
    SET_DOWNLOAD_XOSC_FILE_SUCCESS,
    SET_DOWNLOAD_XOSC_FILE_ERROR,
    SET_DOWNLOAD_XOSC_FILE_RESET,
    SET_DOWNLOAD_GROUND_TRUTH_FILE_REQUEST,
    SET_DOWNLOAD_GROUND_TRUTH_FILE_SUCCESS,
    SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR,
    SET_DOWNLOAD_GROUND_TRUTH_FILE_RESET,
    SET_AVAILABLE_KPI_LIST_REQUEST,
    SET_AVAILABLE_KPI_LIST_SUCCESS,
    SET_AVAILABLE_KPI_LIST_ERROR,
    SET_AVAILABLE_KPI_LIST_RESET,
    SET_ENABLE_SPECIFIC_KPI,
    SET_SELECT_ALL_AVAILABLE_KPI,
    SET_DESELECT_ALL_AVAILABLE_KPI,
    SET_DOWNLOAD_KPI_FILES_REQUEST,
    SET_DOWNLOAD_KPI_FILES_SUCCESS,
    SET_DOWNLOAD_KPI_FILES_ERROR,
    SET_DOWNLOAD_KPI_FILES_RESET,
} from "./../../../../constants/closeLoop/kpiDashboard/download/downloadReportsConstants";

export const downloadXOSCFile = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_DOWNLOAD_XOSC_FILE_REQUEST });
        const endPoint = "/close_loop/scenario/xosc_file/download";
        axios
            .post(endPoint, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const fileName = response.headers["content-disposition"].split("filename=")[1];
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // IE variant
                        window.navigator.msSaveOrOpenBlob(
                            new Blob([response.data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            }),
                            fileName
                        );
                    } else {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            })
                        );
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute(
                            "download",
                            response.headers["content-disposition"].split("filename=")[1]
                        );
                        document.body.appendChild(link);
                        link.click();
                        dispatch({ type: SET_DOWNLOAD_XOSC_FILE_SUCCESS, payload: fileName });
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: SET_DOWNLOAD_XOSC_FILE_ERROR,
                    payload: error.response.data.message,
                });
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_DOWNLOAD_XOSC_FILE_ERROR, payload: error.message });
    }
};

export const resetDownloadXOSCFileStatus = () => (dispatch) => {
    dispatch({ type: SET_DOWNLOAD_XOSC_FILE_RESET });
};

export const downloadGroundTruthFiles = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_DOWNLOAD_GROUND_TRUTH_FILE_REQUEST });
        const url = "/close_loop/scenario_execution/ground_truth_files/download";
        axios
            .post(url, payload, { responseType: "blob" })
            .then((response) => {
                if (response && response.status === 200) {
                    const fileName = response.headers["content-disposition"].split("filename=")[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        response.headers["content-disposition"].split("filename=")[1]
                    );
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: SET_DOWNLOAD_GROUND_TRUTH_FILE_SUCCESS, payload: fileName });
                }
            })
            .catch((error) => {
                console.log(error);
                // dispatch({type: SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR, payload: error.response.data.message});
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //     && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({
                        type: SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR,
                        payload: error.response.data.message,
                    });
                } else {
                    dispatch({
                        type: SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR, payload: error.message });
    }
};

export const resetDownloadGroundFiles = () => (dispatch) => {
    dispatch({ type: SET_DOWNLOAD_GROUND_TRUTH_FILE_RESET });
};

export const fetchAvailableKPI = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_AVAILABLE_KPI_LIST_REQUEST });
        const url = "/close_loop/fetch/available/kpi_files";
        axios
            .post(url, payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const { data } = response;
                    dispatch({ type: SET_AVAILABLE_KPI_LIST_SUCCESS, payload: data["kpi"] });
                }
            })
            .catch((error) => {
                console.log(error);
                error.response.data.message
                    ? dispatch({
                          type: SET_AVAILABLE_KPI_LIST_ERROR,
                          payload: error.response.data.message,
                      })
                    : dispatch({
                          type: SET_AVAILABLE_KPI_LIST_ERROR,
                          payload: "Error Occurred while fetching kpi files",
                      });
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_AVAILABLE_KPI_LIST_ERROR, payload: error.message });
    }
};

export const resetAvailableKPIList = () => (dispatch) => {
    dispatch({ type: SET_AVAILABLE_KPI_LIST_RESET });
};

export const setSpecificKPI = (payload) => (dispatch) => {
    dispatch({ type: SET_ENABLE_SPECIFIC_KPI, payload });
};

export const selectAllAvailableKPI = () => (dispatch) => {
    dispatch({ type: SET_SELECT_ALL_AVAILABLE_KPI });
};

export const deselectAllAvailableKPI = () => (dispatch) => {
    dispatch({ type: SET_DESELECT_ALL_AVAILABLE_KPI });
};

export const downloadKPIFiles = (payload) => (dispatch) => {
    try {
        dispatch({ type: SET_DOWNLOAD_KPI_FILES_REQUEST });
        const url = "/close_loop/kpi_files/download";
        axios
            .post(url, payload, { responseType: "blob" })
            .then((response) => {
                if (response && response.status === 200) {
                    // const fileName = response.headers["content-disposition"].split("filename=")[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        response.headers["content-disposition"].split("filename=")[1]
                    );
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: SET_DOWNLOAD_KPI_FILES_SUCCESS });
                }
            })
            .catch((error) => {
                console.log(error);
                error.response.data.message
                    ? dispatch({
                          type: SET_DOWNLOAD_KPI_FILES_ERROR,
                          payload: error.response.data.message,
                      })
                    : dispatch({
                          type: SET_DOWNLOAD_KPI_FILES_ERROR,
                          payload: "Error occurred while download files",
                      });
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: SET_DOWNLOAD_KPI_FILES_ERROR, payload: error.message });
    }
};

export const resetDownloadKPIFiles = () => (dispatch) => {
    dispatch({ type: SET_DOWNLOAD_KPI_FILES_RESET });
};
